import store from "../../store";

const getLinkByCode = (code) => {
  try {
    if(!code) return null;
    let links = store.getters.getLinksExternalData;

    if (links && links != "undefined") {
      for (var i = 0; i < links.length; i++) {
        const isExist = code == links[i].code
        if (isExist) {
          return links[i].description
        }
      }
    }
    return null;
  } catch (error) {
    console.error(`Error on is code not found =>  ${code}: `, error);
    return null;
  }
};
 
export { getLinkByCode };
